module.exports = __webpack_public_path__ + "img/DK36532130.f644826c.png";